// import Vue from 'vue'
import store from '@/store/store'

import XRegExp from 'xregexp'

export function setValidator (selector = '') {
  let result = ''
  const validatorData = require('./en').default
  /*try {
    const validatorFile = store.state.locale.validator
    validatorData = require(`./${validatorFile}`).default
  }
  catch (e) {
    validatorData = require('./fa').default
  }*/

  if (selector) {
    result = validatorData
    let hasError = false
    selector.split('.').forEach((validator) => {
      if (result.hasOwnProperty(validator)) {
        result = result[validator]
      } else {
        hasError = true
        return false
      }
    })

    if (typeof result === 'object' && Object.keys(result).length > 0) {
      hasError = true
    }

    if (!hasError) {
      let parsedRegexLang = ''
      const clubRegex = /*store.state.setting.clubInfo.club_language_regex_script*/ 'L_M_N'
      if (clubRegex) {
        if (clubRegex.indexOf('_') > -1) {
          clubRegex.split('_').forEach((item) => {
            parsedRegexLang += `\\p{${item}}`
          })
        } else {
          parsedRegexLang += `\\p{${clubRegex}}`
        }
      }
      if (typeof result === 'string' && result.includes('{langRegex}')) {
        return XRegExp(result.replace('{langRegex}', parsedRegexLang))
      } else {
        return XRegExp(result)
      }
    } else {
      return selector
    }
  } else {
    return selector
  }
}
